module.exports = __webpack_public_path__ + "img/101005.7034663a.png";